import { SupportCategory, SupportProblem, SupportSolution, SupportKnowledge } from '@/types/support';

export const supportCategories: SupportCategory[] = [
  {
    id: 'streak',
    name: 'Streak (pontuação diária)',
    description: 'Problemas relacionados ao sistema de pontos e streak diário',
    keywords: ['streak', 'pontos', 'pontuação', 'diário', 'zerou', 'quebrou', 'contabilizar'],
    priority: 1
  },
  {
    id: 'receiving',
    name: 'Problemas de recebimento das edições e cadastro',
    description: 'Dificuldades para receber as newsletters ou problemas com cadastro',
    keywords: ['não recebo', 'não chega', 'email', 'spam', 'cadastro', 'desinscrevi'],
    priority: 2
  },
  {
    id: 'referral',
    name: 'Programa de indicação e prêmios',
    description: 'Questões sobre indicações, prêmios e recompensas',
    keywords: ['indicação', 'prêmio', 'recompensa', 'indicar', 'amigo', 'código'],
    priority: 3
  },
  {
    id: 'account',
    name: 'Alteração de cadastro',
    description: 'Mudanças em informações da conta',
    keywords: ['alterar', 'mudar', 'trocar', 'email', 'dados'],
    priority: 4
  },
  {
    id: 'cancellation',
    name: 'Problemas de cancelamento',
    description: 'Questões sobre desinscrição e cancelamento',
    keywords: ['cancelar', 'desinscrever', 'parar', 'continuo recebendo'],
    priority: 5
  }
];

export const supportProblems: SupportProblem[] = [
  // PROBLEMAS DE STREAK
  {
    id: 'streak-not-counting',
    categoryId: 'streak',
    title: 'Meus pontos no streak não estão sendo contabilizados',
    description: 'O streak não está registrando corretamente ou foi zerado',
    keywords: ['pontos', 'não conta', 'zerou', 'quebrou', 'resetou'],
    frequency: 1371,
    newsletter: ['thenews', 'waffle']
  },
  {
    id: 'streak-sunday-monday',
    categoryId: 'streak',
    title: 'Streak quebrou no domingo ou segunda-feira',
    description: 'O streak zera na virada do fim de semana',
    keywords: ['domingo', 'segunda', 'fim de semana', 'zerou'],
    frequency: 450,
    newsletter: ['thenews', 'waffle']
  },
  {
    id: 'streak-multiple-devices',
    categoryId: 'streak',
    title: 'Problemas com streak em múltiplos dispositivos',
    description: 'Alternar entre celular e computador causa problemas',
    keywords: ['celular', 'computador', 'dispositivo', 'alternando'],
    frequency: 320,
    newsletter: ['thenews', 'waffle']
  },
  {
    id: 'streak-time-limit',
    categoryId: 'streak',
    title: 'Dúvida sobre horário limite do streak',
    description: 'Qual o horário limite para registrar o streak diário',
    keywords: ['horário', 'limite', 'quando', 'até que horas'],
    frequency: 280,
    newsletter: ['thenews', 'waffle']
  },
  {
    id: 'streak-night-edition',
    categoryId: 'streak',
    title: 'Preciso marcar streak na edição noturna?',
    description: 'Confusão sobre necessidade de marcar nas edições noturnas',
    keywords: ['noturna', 'edição noturna', 'duas vezes'],
    frequency: 321,
    newsletter: ['thenews', 'waffle']
  },

  // PROBLEMAS DE RECEBIMENTO
  {
    id: 'not-receiving-edition',
    categoryId: 'receiving',
    title: 'Não estou recebendo a edição',
    description: 'Newsletter não chega no email',
    keywords: ['não recebo', 'não chega', 'parou', 'sumiu'],
    frequency: 413,
    newsletter: ['all']
  },
  {
    id: 'email-in-spam',
    categoryId: 'receiving',
    title: 'Emails indo para spam',
    description: 'Newsletter está caindo na pasta de spam ou promoções',
    keywords: ['spam', 'lixo', 'promoções', 'caixa de spam'],
    frequency: 150,
    newsletter: ['all']
  },
  {
    id: 'unsubscribed-by-mistake',
    categoryId: 'receiving',
    title: 'Me desinscrevi por engano',
    description: 'Cancelou a inscrição acidentalmente e quer voltar',
    keywords: ['desinscrevi', 'engano', 'voltar', 'reinscrever'],
    frequency: 50,
    newsletter: ['all']
  },
  {
    id: 'wrong-email',
    categoryId: 'receiving',
    title: 'Email cadastrado está errado',
    description: 'Cadastrou com email incorreto',
    keywords: ['email errado', 'digitei errado', 'outro email'],
    frequency: 72,
    newsletter: ['all']
  },

  // PROBLEMAS DE INDICAÇÃO
  {
    id: 'cant-refer-friends',
    categoryId: 'referral',
    title: 'Não estou conseguindo indicar o the news',
    description: 'Problemas para indicar amigos',
    keywords: ['indicar', 'não consigo', 'link', 'código'],
    frequency: 149,
    newsletter: ['thenews', 'waffle']
  },
  {
    id: 'referral-link-missing',
    categoryId: 'referral',
    title: 'Link de indicação não aparece',
    description: 'Não encontra o link ou código de indicação',
    keywords: ['link', 'não aparece', 'onde está', 'código'],
    frequency: 60,
    newsletter: ['thenews', 'waffle']
  },
  {
    id: 'referral-code-not-working',
    categoryId: 'referral',
    title: 'Código de indicação não funciona',
    description: 'Código não é aceito ou dá erro',
    keywords: ['código', 'não funciona', 'erro', 'inválido'],
    frequency: 45,
    newsletter: ['thenews', 'waffle']
  },
  {
    id: 'referral-email-exists',
    categoryId: 'referral',
    title: 'Email do indicado já está cadastrado',
    description: 'Tentando indicar alguém que já é inscrito',
    keywords: ['já cadastrado', 'email existe', 'já inscrito'],
    frequency: 44,
    newsletter: ['thenews', 'waffle']
  },
  {
    id: 'prizes-not-received',
    categoryId: 'referral',
    title: 'Não recebi meus prêmios',
    description: 'Prêmios do programa de indicação não chegaram',
    keywords: ['prêmio', 'não recebi', 'não chegou', 'cadê'],
    frequency: 93,
    newsletter: ['thenews', 'waffle']
  },
  {
    id: 'defective-prize',
    categoryId: 'referral',
    title: 'Meu prêmio chegou com defeito',
    description: 'Produto recebido está danificado ou com defeito',
    keywords: ['defeito', 'quebrado', 'danificado', 'problema'],
    frequency: 11,
    newsletter: ['thenews', 'waffle']
  },

  // PROBLEMAS DE CONTA
  {
    id: 'change-email',
    categoryId: 'account',
    title: 'Como altero meu email cadastrado?',
    description: 'Precisa trocar o email da conta',
    keywords: ['alterar email', 'trocar email', 'mudar email'],
    frequency: 72,
    newsletter: ['all']
  },

  // PROBLEMAS DE CANCELAMENTO
  {
    id: 'still-receiving-after-cancel',
    categoryId: 'cancellation',
    title: 'Me desinscrevi mas continuo recebendo',
    description: 'Ainda recebe emails após cancelamento',
    keywords: ['desinscrevi', 'continuo recebendo', 'ainda recebo'],
    frequency: 50,
    newsletter: ['all']
  },
  {
    id: 'lost-streak-account-access',
    categoryId: 'streak',
    title: 'Perdi meu streak por não conseguir acessar minha conta',
    description: 'Problemas de acesso à conta causando perda de streak',
    keywords: ['perdi', 'acessar', 'conta', 'redefinir'],
    frequency: 89,
    newsletter: ['thenews', 'waffle']
  }
];

export const supportSolutions: SupportSolution[] = [
  // SOLUÇÕES PARA STREAK
  {
    id: 'sol-streak-not-counting',
    problemId: 'streak-not-counting',
    title: 'Como marcar corretamente sua leitura do dia',
    content: 'Vamos te ajudar a entender como marcar corretamente seu Streak e resolver problemas de contabilização.',
    steps: [
      {
        order: 1,
        title: 'Abra a edição pelo e-mail',
        description: 'Você precisa abrir a edição do dia PELO E-MAIL e clicar no banner de marcação do Streak, que fica logo acima da primeira matéria.',
        warningMessage: 'Importante: A leitura só conta quando você clica direto no e-mail!'
      },
      {
        order: 2,
        title: 'Clique no banner do Streak',
        description: 'Localize e clique no banner de marcação do Streak que fica logo acima da primeira matéria.',
        warningMessage: 'A leitura só é contabilizada com o click no banner!'
      },
      {
        order: 3,
        title: 'Aguarde a página carregar completamente',
        description: 'Espere a página carregar até o final. Não saia da página antes do carregamento completo para garantir a marcação.'
      },
      {
        order: 4,
        title: 'Verifique o horário limite',
        description: 'O Streak deve ser registrado até 23h59 do mesmo dia. Se você abriu a edição depois deste prazo, não será contabilizado.',
        warningMessage: 'Horário limite: 23h59 do dia da edição'
      },
      {
        order: 5,
        title: 'Possíveis problemas',
        description: 'Verificações importantes: Você saiu da página antes dela carregar? Abriu pela versão web em vez do e-mail? Usou um e-mail diferente? Já tinha marcado o Streak hoje (só conta uma vez)?'
      },
      {
        order: 6,
        title: 'Edições diurna e noturna',
        description: 'Você NÃO precisa marcar nas duas edições. O Streak conta só uma vez por dia - escolha marcar na edição diurna OU na noturna.',
        warningMessage: 'Marque apenas uma vez por dia!'
      }
    ],
    requiredActions: [
      {
        type: 'validate_email',
        description: 'Verifique se está usando o e-mail correto e clicando direto no banner da edição'
      },
      {
        type: 'contact_support',
        description: 'Se seguiu todos os passos corretamente e o Streak não foi contabilizado, abra um chamado'
      }
    ],
    successRate: 0.85,
    timeToResolve: '2-5 minutos',
    lastUpdated: new Date('2025-08-25')
  },

  {
    id: 'sol-streak-sunday-monday',
    problemId: 'streak-sunday-monday',
    title: 'Streak quebrou no fim de semana',
    content: 'Entenda como funciona o streak no fim de semana.',
    steps: [
      {
        order: 1,
        title: 'Verifique o horário de marcação',
        description: 'No domingo, marque seu streak antes das 23h59. O sistema considera o horário de Brasília.'
      },
      {
        order: 2,
        title: 'Segunda-feira',
        description: 'Na segunda, você tem das 00h00 às 23h59 para marcar o streak do dia.'
      },
      {
        order: 3,
        title: 'Capture evidências',
        description: 'Tire print da tela ao marcar o streak, especialmente nos fins de semana.',
        warningMessage: 'Guarde os prints como comprovante!'
      },
      {
        order: 4,
        title: 'Se quebrou injustamente',
        description: 'Com os prints em mãos, entre em contato com o suporte informando a data e horário exatos.'
      }
    ],
    requiredActions: [
      {
        type: 'contact_support',
        description: 'Se o streak quebrou injustamente, precisaremos verificar manualmente',
        metadata: { requiresEvidence: true }
      }
    ],
    successRate: 0.75,
    timeToResolve: '24-48 horas',
    lastUpdated: new Date('2025-08-25')
  },

  // SOLUÇÕES PARA RECEBIMENTO
  {
    id: 'sol-not-receiving',
    problemId: 'not-receiving-edition',
    title: 'Newsletter não está chegando',
    content: 'Vamos resolver o problema de recebimento das edições.',
    steps: [
      {
        order: 1,
        title: 'Verifique a pasta de Spam/Promoções',
        description: 'Verifique se os emails não estão indo para as pastas de Spam, Lixo Eletrônico ou Promoções.',
        warningMessage: 'Verifique TODAS as pastas do seu email!'
      },
      {
        order: 2,
        title: 'Marque como "Não é spam"',
        description: 'Se encontrar na pasta de spam, marque como "Não é spam" para treinar o filtro do seu email.'
      },
      {
        order: 3,
        title: 'Adicione o remetente aos contatos',
        description: 'Adicione o email do remetente aos seus contatos para garantir que as edições cheguem na caixa principal.'
      },
      {
        order: 4,
        title: 'Confirme o email cadastrado',
        description: 'Verifique se o email cadastrado está correto. Confirme se você não digitou errado na hora do cadastro.'
      },
      {
        order: 5,
        title: 'Verifique qual edição não está chegando',
        description: 'Identifique se é a edição principal ou noturna. Para a edição noturna, verifique se você está inscrito especificamente nela.'
      },
      {
        order: 6,
        title: 'Se cancelou por engano',
        description: 'Se você se desinscreveu acidentalmente, solicite reinscrição ao suporte informando seu email original e quais edições deseja receber.',
        warningMessage: 'Reativação em 24-48h'
      }
    ],
    requiredActions: [
      {
        type: 'check_spam',
        description: 'Verificar pasta de spam é essencial'
      },
      {
        type: 'wait_time',
        description: 'Aguardar 24h para próxima edição',
        metadata: { hours: 24 }
      }
    ],
    successRate: 0.92,
    timeToResolve: '24 horas',
    lastUpdated: new Date('2025-08-25')
  },

  {
    id: 'sol-unsubscribed-mistake',
    problemId: 'unsubscribed-by-mistake',
    title: 'Como voltar a receber após desinscrever por engano',
    content: 'Vamos reativar sua inscrição na newsletter.',
    steps: [
      {
        order: 1,
        title: 'Entre em contato com o suporte',
        description: 'Para reinscrever-se, você precisa entrar em contato com o suporte informando o email original.'
      },
      {
        order: 2,
        title: 'Especifique as edições desejadas',
        description: 'Informe quais edições deseja receber (edição principal, noturna ou ambas).'
      },
      {
        order: 3,
        title: 'Aguarde confirmação',
        description: 'A reativação geralmente ocorre em 24-48 horas. Você receberá um email confirmando a reinscrição.',
        warningMessage: 'Prazo de reativação: 24-48h'
      }
    ],
    requiredActions: [
      {
        type: 'contact_support',
        description: 'Reativação manual pode ser necessária',
        metadata: { manual: true }
      }
    ],
    successRate: 0.70,
    timeToResolve: '24-48 horas',
    lastUpdated: new Date('2025-08-25')
  },

  // SOLUÇÕES PARA INDICAÇÃO
  {
    id: 'sol-cant-refer',
    problemId: 'cant-refer-friends',
    title: 'Como indicar o the news corretamente',
    content: 'Vamos te ajudar a indicar amigos e ganhar prêmios.',
    steps: [
      {
        order: 1,
        title: 'Obtenha seu link de indicação',
        description: 'Você pode obter o seu link pessoal na aba "Indicar" do site thenewscc.com.br/streak',
        warningMessage: 'Use sempre seu link pessoal!'
      },
      {
        order: 2,
        title: 'Como funciona o programa',
        description: 'Cada amigo que se cadastra usando o seu link pessoal e confirma a inscrição por e-mail conta como uma indicação sua. Com isso, você acumula pontos para trocar por prêmios.'
      },
      {
        order: 3,
        title: 'Indicação não apareceu?',
        description: 'Possíveis motivos: O indicado não confirmou o e-mail de cadastro (sem confirmação, não conta). O e-mail já estava cadastrado na base antes. A indicação não foi feita usando seu link pessoal.',
        warningMessage: 'Confirmação de e-mail é obrigatória!'
      },
      {
        order: 4,
        title: 'Guia completo',
        description: 'Temos um guia especial explicando o passo-a-passo. Acesse: waffleinc.notion.site/guia-oficial-de-como-indicar-o-the-news'
      }
    ],
    requiredActions: [
      {
        type: 'clear_cache',
        description: 'Limpar cache pode resolver problemas de visualização'
      },
      {
        type: 'validate_email',
        description: 'Verificar se email já não está cadastrado'
      }
    ],
    successRate: 0.88,
    timeToResolve: '5-10 minutos',
    lastUpdated: new Date('2025-08-25')
  },

  {
    id: 'sol-prizes-not-received',
    problemId: 'prizes-not-received',
    title: 'Informações sobre prêmios do programa de indicação',
    content: 'Entenda os prazos e processo de envio dos prêmios.',
    steps: [
      {
        order: 1,
        title: 'Prazo de envio',
        description: 'O envio dos prêmios leva entre 30 e 45 dias após a confirmação das indicações.',
        warningMessage: 'Prazo: 30 a 45 dias após confirmação'
      },
      {
        order: 2,
        title: 'Verifique se atingiu as indicações',
        description: 'Confirme se você atingiu o número mínimo de indicações necessário para o prêmio desejado.'
      },
      {
        order: 3,
        title: 'Preencha o formulário de endereço',
        description: 'Confira se você preencheu o formulário com o endereço de envio completo e correto.'
      },
      {
        order: 4,
        title: 'Espere o prazo de processamento',
        description: 'Aguarde o prazo completo de processamento antes de entrar em contato.'
      },
      {
        order: 5,
        title: 'Se passou o prazo',
        description: 'Se o prazo já passou, abra um ticket com seu e-mail e prêmio não recebido que verificamos na hora!',
        warningMessage: 'Só abra ticket após 45 dias'
      },
      {
        order: 6,
        title: 'Prêmio com defeito?',
        description: 'Sem estresse! Entre em contato no yellow@thenewscc.com.br com fotos do item defeituoso. Te mandaremos um novo!',
        warningMessage: 'Inclua fotos do produto defeituoso'
      }
    ],
    requiredActions: [
      {
        type: 'wait_time',
        description: 'Aguardar prazo de processamento',
        metadata: { days: 45 }
      },
      {
        type: 'contact_support',
        description: 'Após o prazo, contato necessário',
        metadata: { afterDeadline: true }
      }
    ],
    successRate: 0.95,
    timeToResolve: '30-45 dias',
    lastUpdated: new Date('2025-08-25')
  },

  // SOLUÇÕES PARA CONTA
  {
    id: 'sol-change-email',
    problemId: 'change-email',
    title: 'Alterar email cadastrado',
    content: 'Como trocar seu email de cadastro.',
    steps: [
      {
        order: 1,
        title: 'Acesse sua conta',
        description: 'Clique no link "Gerenciar assinatura" no rodapé do email.'
      },
      {
        order: 2,
        title: 'Vá para Configurações',
        description: 'Procure por "Configurações" ou "Meu Perfil" no menu.'
      },
      {
        order: 3,
        title: 'Atualize o email',
        description: 'Digite o novo email e confirme a alteração.'
      },
      {
        order: 4,
        title: 'Confirme nos dois emails',
        description: 'Você receberá emails de confirmação tanto no email antigo quanto no novo.',
        warningMessage: 'Confirme em AMBOS os emails!'
      }
    ],
    requiredActions: [
      {
        type: 'validate_email',
        description: 'Confirmação necessária em ambos os emails'
      }
    ],
    successRate: 0.90,
    timeToResolve: '5-10 minutos',
    lastUpdated: new Date('2025-08-25')
  },

  // SOLUÇÕES PARA CANCELAMENTO
  {
    id: 'sol-still-receiving',
    problemId: 'still-receiving-after-cancel',
    title: 'Ainda recebendo após cancelar',
    content: 'Como garantir o cancelamento definitivo.',
    steps: [
      {
        order: 1,
        title: 'Use o link correto',
        description: 'Clique em "Descadastrar" no rodapé do email mais recente que recebeu.'
      },
      {
        order: 2,
        title: 'Confirme o cancelamento',
        description: 'Aguarde a página de confirmação e o email de confirmação do cancelamento.'
      },
      {
        order: 3,
        title: 'Verifique múltiplas newsletters',
        description: 'Você pode estar inscrito em várias newsletters (principal, noturna, outras). Cancele cada uma separadamente.'
      },
      {
        order: 4,
        title: 'Aguarde 48 horas',
        description: 'O processamento do cancelamento pode levar até 48 horas.',
        warningMessage: 'Processamento em até 48h'
      },
      {
        order: 5,
        title: 'Se persistir',
        description: 'Após 48h, se continuar recebendo, tire prints e abra um ticket com evidências.'
      }
    ],
    requiredActions: [
      {
        type: 'wait_time',
        description: 'Aguardar processamento',
        metadata: { hours: 48 }
      },
      {
        type: 'contact_support',
        description: 'Se persistir após 48h',
        metadata: { requiresEvidence: true }
      }
    ],
    successRate: 0.98,
    timeToResolve: '48 horas',
    lastUpdated: new Date('2025-08-25')
  },
  {
    id: 'sol-lost-streak-account-access',
    problemId: 'lost-streak-account-access',
    title: 'Problemas de acesso à conta e cadastro de senha',
    content: 'Como resolver problemas de acesso e cadastrar senha para contas existentes.',
    steps: [
      {
        order: 1,
        title: 'Implementamos cadastro de senha',
        description: 'Agora é possível cadastrar uma senha para sua conta existente.',
        warningMessage: 'Suas contas existentes NÃO perderão os dados!'
      },
      {
        order: 2,
        title: 'Cadastre como primeira vez',
        description: 'Use o mesmo email que recebe as newsletters e cadastre uma senha como se fosse um novo usuário.'
      },
      {
        order: 3,
        title: 'Seu streak será preservado',
        description: 'Todos os seus dados, incluindo streak e pontuação, serão mantidos na conta existente.'
      },
      {
        order: 4,
        title: 'Acesso garantido',
        description: 'Após o cadastro da senha, você terá acesso completo à sua conta e poderá marcar seu streak normalmente.'
      },
      {
        order: 5,
        title: 'Se houver problemas',
        description: 'Em caso de dificuldades, entre em contato com o suporte informando seu email cadastrado.',
        isOptional: true
      }
    ],
    requiredActions: [
      {
        type: 'contact_support',
        description: 'Cadastrar senha para conta existente'
      },
      {
        type: 'contact_support',
        description: 'Suporte disponível se necessário',
        metadata: { optional: true }
      }
    ],
    successRate: 0.95,
    timeToResolve: '5-10 minutos',
    lastUpdated: new Date('2025-01-27')
  }
];

export const knowledgeBase: SupportKnowledge = {
  categories: supportCategories,
  problems: supportProblems,
  solutions: supportSolutions
};